/**
 * Buy Now 按钮功能
 * 用于特殊商品页面(m1, p1, f1 等)
 * 点击 Buy Now 按钮后直接跳转到结账页面,跳过购物车
 */

document.addEventListener('DOMContentLoaded', function() {
  // 为所有带有 .buy-now-btn 类的按钮添加点击事件
  document.querySelectorAll('.buy-now-btn').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault(); // 防止默认行为
      window.showNoticeDialog()
    });
  });
});
// document.addEventListener('DOMContentLoaded', function() {
//   // 为所有带有 .buy-now-btn 类的按钮添加点击事件
//   document.querySelectorAll('.buy-now-btn').forEach(button => {
//     button.addEventListener('click', function(e) {
//       e.preventDefault(); // 防止默认行为

//       const variantId = this.dataset.variantId;
//       const originalText = this.textContent;

//       // 验证 variant ID 是否存在
//       if (!variantId || variantId === '' || variantId === 'null' || variantId === 'undefined') {
//         console.error('Variant ID not found or invalid:', variantId);
//         alert('Product variant not found. Please refresh the page and try again.');
//         return;
//       }

//       // 确保 variant ID 是数字
//       const numericVariantId = parseInt(variantId, 10);
//       if (isNaN(numericVariantId)) {
//         console.error('Variant ID is not a valid number:', variantId);
//         alert('Invalid product variant. Please refresh the page and try again.');
//         return;
//       }

//       console.log('Adding to cart - Variant ID:', numericVariantId);

//       // 禁用按钮并显示加载状态
//       this.disabled = true;
//       this.textContent = 'Adding...';
//       this.style.cursor = 'not-allowed';

//       // 使用 Shopify Cart API 添加商品到购物车
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           items: [{
//             id: numericVariantId,
//             quantity: 1
//           }]
//         })
//       })
//       .then(response => {
//         // 检查响应状态
//         if (!response.ok) {
//           // 尝试解析错误响应
//           return response.json().then(errorData => {
//             console.error('Server error response:', errorData);
//             throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
//           }).catch(() => {
//             throw new Error(`HTTP error! status: ${response.status}`);
//           });
//         }
//         return response.json();
//       })
//       .then(data => {
//         console.log('Product added to cart successfully:', data);
//         // 成功添加后直接跳转到结账页面
//         window.location.href = '/checkout';
//       })
//       .catch(error => {
//         // 如果出错,恢复按钮状态并提示用户
//         console.error('Error adding to cart:', error);
//         this.disabled = false;
//         this.textContent = originalText;
//         this.style.cursor = 'pointer';
//         alert('Failed to add product to cart: ' + error.message);
//       });
//     });
//   });
// });
